import { ClimaproData } from './portal';

export enum AlertType {
	Maintenance = 'maintenance',
	Itv = 'itv',
	Delivery = 'delivery',
	Vouchers = 'vouchers',
}
export interface Vehicle {
	id: string; //Antes: ID
	extKey: string; //Antes: vehicleClimaproId
	name: string; // antes: frame
	image: string;
	vgedModelGroup: string; //Antes: comercialDenomination
	vgedModel: string; //Antes: comercialDenominationSli
	modelKey: string; //Antes: tmaimg
	vgedRegistrationPlate: string | null; //Antes: license
	vgedRegistrationDate: string | null; // Antes: licenseDate
	modelYear: string; //Antes: modelYear
	vgedMileage: number; // antes: localKM / climaproKm
	alertNextMaintenance: boolean;
	alertPreITV: boolean;
	status: VehicleStatus;
	mediaAssets: VehiclesMediaAssets;
	assets: VehicleAsset[]; //flagIsVO aqui dentro
	longdrive: VehicleLongdrive | null;
	warranty: VehicleWarranty | undefined | null;
}

export interface Order {
	id: string;
	name: string; // Antes: orderCode
	status: string;
	image?: string;
	vgedCommunicationModel: string; // nombre modelo
	rcyVin: string; // Antes: frame, en orders es el vin
	rcyActualDeliveryDate?: string; // Antes: deliveryDate
	vgedCustomersOrderDate: string; // Antes: orderDate
}

export type VehicleAsset = {
	vgedRelationshipType: string;
	vgedIsVo: boolean;
};

export interface VehicleWithAlerts extends Vehicle {
	alertType: AlertType;
}

export enum VehicleStatus {
	'READY' = 'READY',
	'TO_BE_CONFIRMED' = 'TO_BE_CONFIRMED',
	'TO_BE_CREATED' = 'TO_BE_CREATED',
	'TO_BE_DELETED' = 'TO_BE_DELETED',
	'DELETED' = 'DELETED',
	'ORDER' = 'ORDER',
	'DELIVERED' = 'DELIVERED',
}

export type VehiclesMediaAssets = {
	Back_Left: string;
	Back_Right: string;
	Front_Center: string;
	Front_Left: string;
	Front_Right: string;
	Interior_Center_Center: string;
	Interior_Lhd_Center: string;
	Interior_Rhd_Center: string;
	Interior_Seat: string;
	Interior_Side: string;
	Side_Left: string;
	Side_Right: string;
	Wheel: string;
};

export type DataVehicles = {
	identitykitId: string;
	climapro: ClimaproData;
	vehicles: Vehicle[];
	orders?: Order[];
};

export enum ErrorType {
	NonDefined = 'Non defined',
	ConfirmVehicle = 'Confirm vehicle',
	AddVehicle = 'Add vehicle',
	AddVehicleClub = 'Add vehicle Club',
	DeleteVehicle = 'Delete vehicle',
	ConfirmData = 'Confirm name and license',
}

export type VehicleWarranty = {
	// Garantia fabricante:
	vgedYearsWarrantyCoverage: number; // Años de cobertura de garantía de fabricante - anyosCoberturaGarantia

	// Extensión garantía:
	vgedWarrantyExtension?: number; // Codigo extension garantia - codPRExtensionGarantia
	vgedYearsWarrantyExtension: number; // Años de extensión de garantía - warrantyExtensionYears
	vgedGuaranteedKmsCoverage?: number; // Máximo KM de extensión de garantía - warrantyCoverageKms
	vgedExtendedWarrantyActive: boolean; // ¿Está el vehículo en extensión de garantía? - flagHiredWarrantyExtension
};

export type VehicleLongdrive = {
	id: number;
	contractCode: string;
	contractDate: number | string;
	contractStartDate: number | string;
	contractEndDate: number | string;
	name: string;
	contractType?: string;
	typeCode: string;
	saleTypeCode: string;
	isBundle: boolean;
	productDesc: string;
	contractedKms: number;
	climaproPersonId: number;
	codPaquete: string;
	product: LongdriveProduct;
	isPro: boolean;
};

enum LongdriveProduct {
	'VOLKSWAGEN LONG DRIVE STANDARD' = 'Standard',
	'VOLKSWAGEN LONG DRIVE ADVANCE' = 'Advance',
	'VOLKSWAGEN LONG DRIVE NEUMÁTICOS' = 'Pro',
}
